// packages
import 'intersection-observer';
import yall from 'yall-js';

// local imports
import { AdLoader } from './ads/loader';
import { boot as bootNav } from './nav';

// Kickstart the ads
const adLoader = new AdLoader({ adSection: window.AD_SECTION });
adLoader.init();

// Kickstart the lazy image loading
document.addEventListener('DOMContentLoaded', () => yall());
bootNav();

//if someone taps div expand the box
var box = document.querySelector('.expandable-box-container');
if (box) {
  var list = document.querySelector('.box-list');
  var toggleWording = document.querySelector('.expand-minimize');
  box.addEventListener('click', expandBox, false);
  // box.addEventListener('touchstart', expandBox, false);

  function expandBox() {
    list.classList.toggle('show');
    if (toggleWording.innerHTML === '+') {
      toggleWording.innerHTML = '-';
    } else {
      toggleWording.innerHTML = '+';
    }
  }
}

let storyRefer = document.querySelector('.story-refer');
storyRefer.addEventListener('mouseenter', function (event) {
  storyRefer.classList.add('active');
  //this.querySelector("img").style.opacity = "0.7"
});

storyRefer.addEventListener('mouseleave', function (event) {
  storyRefer.classList.remove('active');
});
